import React from 'react';
import PropTypes from 'prop-types';
import { ForgeButton } from '@tylertech/forge-react';

const ActionComponent = ({ buttons }) => {
  return (
    <div className="flexContainer withGap">
      {buttons.map((button, index) => (
        <ForgeButton
          key={index}
          variant={button.variant}
          slot="action"
          onClick={button.onClick}
        >
          {button.label}
        </ForgeButton>
      ))}
    </div>
  );
};

ActionComponent.propTypes = {
  buttons: PropTypes.array,
};

export default ActionComponent;
